import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "team-creation-form" }
const _hoisted_2 = { class: "sm:rounded-md" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "team-name",
  class: "onboarding-label"
}, "Project Name", -1)
const _hoisted_5 = { class: "error-msg" }
const _hoisted_6 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_7 = { class: "flex flex-row mt-4 items-baseline" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingButton = _resolveComponent("LoadingButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.projectCreationSubmitted && _ctx.projectCreationSubmitted(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            name: "team-name",
            id: "team-name",
            class: "",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.projectName.$model) = $event))
          }, null, 512), [
            [_vModelText, _ctx.v$.projectName.$model]
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.projectName.$errors, (error) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "input-errors",
              key: error.$uid
            }, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(error.$message), 1)
            ]))
          }), 128)),
          (_ctx.responseError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.responseError), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_LoadingButton, {
            disabled: _ctx.v$.$invalid,
            loading: _ctx.loading
          }, {
            default: _withCtx(() => [
              _createTextVNode("Create Project")
            ]),
            _: 1
          }, 8, ["disabled", "loading"])
        ])
      ])
    ], 32)
  ]))
}